import CircleIcon from '@mui/icons-material/Circle';
import Stack from '@mui/material/Stack';

import config from '../../config/config';
import omit from "lodash/omit";
import './PatientStatusFilter.scss'
import Typography from "@mui/material/Typography";

export const getPatientStatusOptions = status => {
  let options;
  switch (status) {
    case 'all':
      options = {
        Icon: CircleIcon,
        color: config().colors.light,
        text: 'All'
      };
      break;
    case 'unscheduled':
      options = {
        Icon: CircleIcon,
        color: config().colors.secondary,
        text: 'Unscheduled'
      };
      break;
    case 'scheduled':
      options = {
        Icon: CircleIcon,
        color: config().colors.primary,
        text: 'Scheduled'
      };
      break;
    case 'lost':
      options = {
        Icon: CircleIcon,
        color: config().colors.goldSand,
        text: 'Lost'
      };
      break;
    case 'goalsMet':
      options = {
        Icon: CircleIcon,
        color: config().colors.deepTeal,
        text: 'Goals Met'
      };
      break;
    case 'referredOut':
      options = {
        Icon: CircleIcon,
        color: config().colors.teal,
        text: 'Referred Out'
      };
      break;
    default:
      options = {
        Icon: CircleIcon,
        color: 'var(--text)',
        text: 'Filter Patients'
      };
      break;
  }
  return options;
};

const PatientStatusFilter = props => {
  const {itemName, count, filters, useText} = props;
  const options = getPatientStatusOptions(itemName);
  const onTabChange = (status) => {
    props.setPageIndex(0);
    if (itemName === 'all') {
      props.onFilterChange(omit(filters, 'patient_status'));
    } else {
      props.onFilterChange({...filters, patient_status: status});
    }
  };
  let isActive = filters?.patient_status === options.text;
  if (itemName === 'all' && !filters?.patient_status) {
    isActive = true;
  }

  return (
    <Stack
      direction='row'
      spacing={1.5}
      alignItems='center'
      sx={{
        paddingX: {xs: '8px', lg: 0},
        paddingY: {xs: '25.62px', lg: 0},
        cursor: 'pointer',
      }}
      onClick={() => onTabChange(options.text)}
    >
      <options.Icon style={{color: options.color, fontSize: '1.5rem', opacity: props.disabled ? 0.6 : 1}}/>
      {
        !!useText &&
        <Typography
          variant='normal'
          className={`${isActive && 'patient-status-filter__active'}`}
          noWrap
        >
          {options.text} ({count})
        </Typography>
      }
    </Stack>
  );
};

export default PatientStatusFilter;
